import { render, staticRenderFns } from "./documentUploadStep.pug?vue&type=template&id=46952fbf&lang=pug&external"
import script from "./documentUploadStep.js?vue&type=script&lang=js&external"
export * from "./documentUploadStep.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46952fbf')) {
      api.createRecord('46952fbf', component.options)
    } else {
      api.reload('46952fbf', component.options)
    }
    module.hot.accept("./documentUploadStep.pug?vue&type=template&id=46952fbf&lang=pug&external", function () {
      api.rerender('46952fbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Document/views/handleDocumentContainer/components/documentUploadStep/index.vue"
export default component.exports